<template>
  <v-container class="black--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-container
      style="background-color: whitesmoke"
      class="page-init-height black--text"
      id="home-container"
    >
      <!-- top card with color bar -->
      <top_card
        :descr_text="descr_text"
        :title="top_card_title"
        :rsrc="'peer'"
        @art_add_first="art_add_first"
      ></top_card>
      <template>
        <v-expansion-panels multiple v-model="panel_open" inset class="">
          <v-expansion-panel
            class=""
            v-for="(art, artindex) in doc.lst_articles"
            :key="art.article.articlesId"
          >
            <v-expansion-panel-header
              :id="'art' + artindex"
              focusable
              class="grey lighten-3 text-h6 text-md-h6"
            >
              {{ art.article.title }}
              <!-- {{ art.lst_headers[0].header.title }} -->
              <template v-slot:actions>
                <v-icon color="black" x-large> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                v-if="show_admin_controls"
                class="toobar-host w100 d-flex flex-column justify-start align-center pa-0 ma-0 mt-1 mb-6"
              >
                <v-card class="w100 grey lighten-5 pa-1 ma-0">
                  <v-card-actions>
                    <div style="width: 100%">
                      <span class="tool-label mr-2">Article</span>
                      <v-row>
                        <v-col
                          class="col-xs-12 col-md-2 d-flex flex-row justify-start pb-1"
                        >
                          <v-btn
                            title="Move Article Up"
                            x-small
                            elevation="2"
                            class="grey lighten-2 black--text"
                            @click="art_move_up(art.article, rsrc)"
                          >
                            <v-icon small>$chevup</v-icon>
                          </v-btn>
                          <v-btn
                            title="Move Article Down"
                            x-small
                            elevation="2"
                            class="grey lighten-2 black--text"
                            @click="art_move_down(art.article, rsrc)"
                          >
                            <v-icon small>$chevdown</v-icon>
                          </v-btn>
                          <v-btn
                            title="Insert Header Top"
                            x-small
                            elevation="2"
                            class="grey lighten-2 black--text"
                            @click="hdr_add_first(art, rsrc)"
                          >
                            <v-icon small>$plus</v-icon>
                            <span style="font-size: 0.8rem">H</span>
                          </v-btn>
                        </v-col>

                        <v-col
                          class="col-xs-10 d-flex flex-row justify-start pt-0 mt0-16px"
                        >
                          <v-btn
                            title="Edit Article Title"
                            x-small
                            elevation="2"
                            class="grey lighten-5 grey-lighten-1--text"
                            @click="art_edit(art.article, rsrc)"
                          >
                            <v-icon small>$edit</v-icon>
                          </v-btn>

                          <v-btn
                            title="Add Article Above"
                            x-small
                            elevation="2"
                            class="grey lighten-5 grey-lighten-1--text"
                            @click="art_add_up(art.article)"
                          >
                            <v-icon small>$plus</v-icon>
                            <v-icon small>$chevup</v-icon>
                          </v-btn>

                          <v-btn
                            title="Add Article Below"
                            x-small
                            elevation="2"
                            class="grey lighten-5 grey-lighten-1--text"
                            @click="art_add_down(art.article)"
                          >
                            <v-icon small>$plus</v-icon>
                            <v-icon small>$chevdown</v-icon>
                          </v-btn>

                          <v-btn
                            title="Delete Article"
                            x-small
                            elevation="2"
                            class="grey lighten-5 grey-lighten-1--text"
                            @click="art_del(art.article)"
                          >
                            <v-icon small>$del</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-actions>
                </v-card>
              </div>
              <div
                class="hdr_section mt-2"
                v-for="hdr in art.lst_headers"
                :key="hdr.header.headerId"
              >
                <h4 class="header-title" :id="'hdr' + hdr.header.headerId">
                  {{ hdr.header.title }}
                </h4>
                <div
                  v-if="show_admin_controls"
                  class="toobar-host w100 d-flex flex-column justify-start align-center pa-0 ma-0 mt-1 mb-8"
                >
                  <v-card class="w100 grey lighten-5 pa-1 ma-0">
                    <v-card-actions>
                      <div style="width: 100%">
                        <span class="tool-label font-italic mr-2">Header</span>
                        <v-row>
                          <v-col
                            class="col-xs-12 col-md-2 d-flex flex-row justify-start pb-1"
                          >
                            <v-btn
                              title="Move Header Up"
                              x-small
                              elevation="2"
                              class="grey lighten-2 black--text"
                              @click="hdr_move_up(hdr, art, rsrc)"
                            >
                              <v-icon small>$chevup</v-icon>
                            </v-btn>
                            <v-btn
                              title="Move Header Down"
                              x-small
                              elevation="2"
                              class="grey lighten-2 black--text"
                              @click="hdr_move_down(hdr, art, rsrc)"
                            >
                              <v-icon small>$chevdown</v-icon>
                            </v-btn>
                            <v-btn
                              title="Insert Text Item Top"
                              x-small
                              elevation="2"
                              class="grey lighten-2 black--text"
                              @click="ti_add_first(hdr, rsrc)"
                            >
                              <v-icon small>$plus</v-icon>
                              <span style="font-size: 0.8rem">T</span>
                            </v-btn>
                          </v-col>
                          <v-col
                            class="col-xs-12 col-md-10 d-flex flex-row justify-start pt-0 mt0-16px"
                          >
                            <v-btn
                              title="Edit Header"
                              x-small
                              elevation="2"
                              class="grey lighten-5 grey-lighten-1--text"
                              @click="hdr_edit(hdr, art)"
                            >
                              <v-icon small>$edit</v-icon>
                            </v-btn>
                            <v-btn
                              title="Add Header Above"
                              x-small
                              elevation="2"
                              class="grey lighten-5 grey-lighten-1--text"
                              @click="hdr_add_up(hdr, art, rsrc)"
                            >
                              <v-icon small>$plus</v-icon>
                              <v-icon small>$chevup</v-icon>
                            </v-btn>
                            <v-btn
                              title="Add Header Below"
                              x-small
                              elevation="2"
                              class="grey lighten-5 grey-lighten-1--text"
                              @click="hdr_add_below(hdr, art, rsrc)"
                            >
                              <v-icon small>$plus</v-icon>
                              <v-icon small>$chevdown</v-icon>
                            </v-btn>
                            <v-btn
                              title="Delete Header"
                              x-small
                              elevation="2"
                              class="grey lighten-5 grey-lighten-1--text"
                              @click="hdr_del(hdr)"
                            >
                              <v-icon small>$del</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-actions>
                  </v-card>
                </div>
                <div
                  v-for="ti in hdr.lst_text_Items"
                  :key="ti.text_itemId"
                  :id="'ti' + ti.text_itemId"
                >
                  <p class="mb-0 text-item-text" v-html="ti.text_content"></p>
                  <div
                    v-if="show_admin_controls"
                    class="toobar-host w100 d-flex flex-column justify-start align-center pa-0 ma-0 mb-8"
                  >
                    <v-card class="w100 grey lighten-5 pa-1 ma-0">
                      <v-card-actions>
                        <div style="width: 100%">
                          <span class="tool-label font-italic font-bold mr-2"
                            >Text</span
                          >
                          <v-row>
                            <v-col
                              class="col-xs-12 col-md-2 d-flex flex-row justify-start pb-1"
                            >
                              <v-btn
                                title="Text Item Move Up"
                                x-small
                                elevation="2"
                                class="grey lighten-3 grey-lighten-1--text"
                                @click="ti_move_up(ti, hdr)"
                              >
                                <v-icon small>$chevup</v-icon>
                              </v-btn>
                              <v-btn
                                title="Text Item Move Down"
                                x-small
                                elevation="2"
                                class="grey lighten-3 grey-lighten-1--text"
                                @click="ti_move_below(ti, hdr)"
                              >
                                <v-icon small>$chevdown</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col
                              class="col-xs-12 col-md-10 d-flex flex-row justify-start pt-0 mt0-16px"
                            >
                              <v-btn
                                title="Edit Text Item"
                                x-small
                                elevation="2"
                                class="grey lighten-5 grey-lighten-1--text"
                                @click="edit_ti(ti, hdr)"
                              >
                                <v-icon small>$edit</v-icon>
                              </v-btn>
                              <v-btn
                                title="Insert Text Item Above"
                                x-small
                                elevation="2"
                                class="grey lighten-5 grey-lighten-1--text"
                                @click="ti_add_up(ti, hdr)"
                              >
                                <v-icon small>$plus</v-icon>
                                <v-icon small>$chevup</v-icon>
                              </v-btn>
                              <v-btn
                                title="Insert Text Item Below"
                                x-small
                                elevation="2"
                                class="grey lighten-5 grey-lighten-1--text"
                                @click="ti_add_below(ti, hdr)"
                              >
                                <v-icon small>$plus</v-icon>
                                <v-icon small>$chevdown</v-icon>
                              </v-btn>
                              <v-btn
                                title="Delete Text Item"
                                x-small
                                elevation="2"
                                class="grey lighten-5 grey-lighten-1--text"
                                @click="ti_del(ti)"
                              >
                                <v-icon small>$del</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </div>
                  <hr class="horrule" />
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </v-container>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  :deep .v-item-group.v-expansion-panels * p {
    margin-bottom: 16px !important;
  }
  // ::v-deep * p {
  //   margin-bottom: 16px !important;
  // }
  // ::v-deep .v-application p {
  //   margin-bottom: 16px !important;
  // }
  // ::v-deep div .mb-0.text-item-text p {
  //   margin-bottom: 16px !important;
  // }
  .horrule {
    border-top: 5px solid darkgrey;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
  }

  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  .ti-host div img {
    padding: 5x;
    margin-left: 5px;
  }
  .mt0-16px {
    margin-top: 0;
  }
  .w100xs {
    width: 100%;
  }
  .w100 {
    width: 100%;
  }
  .page-init-height {
    min-height: 100dvh;
  }
  .page-size {
    width: 100%;
    max-width: 1025px;
    height: auto;
    margin-top: 115px;
  }
  .pagedown {
    margin-top: 90px;
  }
  .tool-label {
    font-size: 0.85rem;
  }
  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .mt0-16px {
    margin-top: 15px;
  }
  .page-size {
    width: 100%;
    max-width: 1025px;
    height: auto;
    margin-top: 90px;
  }
  .w100xs {
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import { wb_doc_methods } from "../mixins/wb_doc_methods";

import top_card from "../components/top_card.vue";

const titlecard = () => import("./titlecard.vue");

export default {
  name: "peer",
  mixins: [bus_common, wb_doc_methods],
  components: { top_card, titlecard },
  props: ["update_peer", "peer_panel_open"],
  data() {
    return {
      rsrc: "peer",
      top_card_title: "Peer Support",
      saved_sterm: "",
      scroll_pos: 0,
      panel_index: 0,
      panel_open: [],
      editorLimit: 3999,
      ti_edit: {},
      ti_diag: {
        field_label: "Text",
        box_title: "Edit Text ",
        title: "",
        ti_prev_next: "",
        text_content: "",
        text_current: {},
        placeholder: "",
        og_text: "",
        og_order: 0,
      },
      show_ti_diag: false,
      art_diag: {
        art_field_label: "Article Title",
        art_diag_box_title: "Edit Article Title",
        art_diag_title: "",
        art_prev_next: "",
        article_current: {},
        placeholder: "",
      },
      hdr_diag: {
        field_label: "Header Title",
        box_title: "Edit Header Title",
        title: "",
        hdr_prev_next: "",
        header_current: {},
        placeholder: "",
      },
      hdr_diag_title: "",
      valid: true,
      show_art_diag: false,
      show_hdr_diag: false,
      doc: {},
      ti_list: [],
      descr_text: `The Reno Police Department recognizes that its most valuable resource is its employees.  The Reno Police Department's Peer Support Program is intended to provide department personnel with a network of resources which, when combined with other resources in the wellness space, helps to maximize employee resilience and overall mental health, especially during difficult professional or personal circumstances.  Offered here is an ever growing library of resources employees may find helpful to help them achieve their resiliency and mental health goals.  These resources include the Peer Support Team Roster, helpful reference and educational materials, vetted clinicians and practices, and self assessment tools.`,
      nodelsit: [],
    };
  },
  watch: {
    peer_panel_open: function () {
      if (this.peer_panel_open != -1) {
        //set value of penl to incoming value
        this.panel_open = this.peer_panel_open;
        //open it
        this.panel_open();
      }
    },

    update_peer: function () {
      this.get_doc();
    },
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
    "$store.state.sterm": function () {
      this.search();
    },
    panel_open() {
      this.panel_index = this.panel_open;
    },
  },
  computed: {
    show_admin_controls() {
      return this.$store.state.show_admin_controls;
    },
    show_user_controls() {
      return this.$store.state.show_user_controls;
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */

    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    //jm stuff

    onExpansionPanelClick(event) {
      var targetID = event.currentTarget.id;
      return true;
      var self = this;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        setTimeout(
          function () {
            //   window.scroll(0, 3500);
            console.log(targetID);
            const daWindow = document.getElementById("vapp");
            const element = document.getElementById(targetID);
            element.scrollIntoView({ behavior: "smooth" });
          },
          500,
          targetID
        );
      }
    },

    get_doc() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.rsrc = this.rsrc;

      formIn.apiname = "get_doc";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.doc = self.mno(data);
          this.show_loader(false);
          self.build_ti_list();
          // this.add_link_click_handler(self);

          self.search("peer sprit");
          self.table_format();
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    init(self) {
      this.get_doc();
    },
  },
  mounted() {
    console.log("peer  mount");
    String.prototype.replaceAllNow = function (strReplace, strWith) {
      // See http://stackoverflow.com/a/3561711/556609
      var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      var reg = new RegExp(esc, "ig");
      return this.replace(reg, strWith);
    };
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
